import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { siteSettings } from "@/content/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ArrowRight } from "@phosphor-icons/react";

const FAQ = [
  { q: "Il sopralluogo è gratuito?", a: "Sì, il sopralluogo è gratuito nelle zone servite. Serve a capire meglio il bagno, le esigenze e la fattibilità dell'intervento." },
  { q: "Il bagno viene davvero realizzato in 10 giorni?", a: "L'obiettivo è completare i lavori in circa 10 giorni di cantiere, partendo solo quando materiali e organizzazione sono pronti. I tempi possono variare in base alla complessità del bagno e alle condizioni rilevate." },
  { q: "Perché non mostrate i prezzi sul sito?", a: "Perché ogni bagno ha condizioni diverse: misure, impianti, accessi, materiali e livello di intervento cambiano molto da caso a caso. Preferiamo valutare prima il progetto e poi proporre una soluzione chiara." },
  { q: "Posso scegliere materiali e finiture?", a: "Sì. Ti guidiamo nella scelta di piastrelle, sanitari, mobile bagno, doccia, rubinetteria e dettagli, così puoi decidere con più semplicità e meno confusione." },
  { q: "Lavorate solo su ristrutturazioni complete?", a: "Oasi Bagni è pensata soprattutto per chi vuole rifare il bagno con un percorso organizzato e completo. In alcuni casi possiamo valutare anche interventi più mirati." },
  { q: "In quali zone lavorate?", a: "Operiamo principalmente tra Milano, provincia di Milano, zona ovest Milano, Corbetta, Magenta, Abbiategrasso, Vittuone, Sedriano, Arluno, Rho, Legnano, Parabiago, Novara e zone limitrofe." },
];

export default function Faq() {
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <section className="section-pad">
        <div className="max-w-3xl mx-auto px-5 md:px-10">
          <div className="overline mb-4">FAQ</div>
          <h1 className="font-display text-4xl md:text-5xl mb-10">Domande frequenti</h1>
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="card-soft px-5 border-none">
                <AccordionTrigger className="text-left font-medium text-anthracite hover:no-underline" data-testid={`faq-${i}`}>{f.q}</AccordionTrigger>
                <AccordionContent className="text-[#5C5C59] leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="mt-12 text-center">
            <Link to="/prenota-sopralluogo" className="btn-primary inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm">
              Richiedi sopralluogo gratuito <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
      <Footer settings={siteSettings} />
      <WhatsAppFloat number={siteSettings.whatsapp_number} />
    </div>
  );
}
